// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bPHOT","right":"Footer_right__3E-v7","buttons":"Footer_buttons__3z6x1"};